import { getSupplier, isSupplierRegistered } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { A, Box, Button, Well } from '@bridebook/ui';
import WellSectionWrap from '@bridebook/web/app-shared/components/well-section-wrap/well-section-wrap';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { getUnverifiedLink } from '@bridebook/web/lib/supplier/unverified-link';
import componentStyles from './your-business.style';

const YourBusiness = () => {
  const { t } = useTranslation('supplier');
  const supplier = useSelector(getSupplier);
  const isRegistered = useSelector(isSupplierRegistered);
  const market = useMarket();
  if (!supplier?.publicId || isRegistered) {
    return null;
  }

  const { name, publicId } = supplier;
  const cleanedName = name.split(' ').join('+');
  const unverifiedProfileLink = getUnverifiedLink({
    cleanedName,
    publicId,
    market,
  });

  const styles = componentStyles();

  return (
    <div className="mt-10">
      <WellSectionWrap>
        <Well theme="red" size="full">
          <Box>
            <Box as="h5" mt={0} mb={2} style={styles.heading}>
              {t('supplier.yourBusiness.title')}
            </Box>
            <A href={unverifiedProfileLink} target="_blank">
              <Button theme="ghost" color="amber" text={t('supplier.yourBusiness.claim')} />
            </A>
          </Box>
        </Well>
      </WellSectionWrap>
    </div>
  );
};

export default YourBusiness;
